import React from 'react';
import { isReleaseDateExpired } from 'lib/expiry-date';
import { Pill } from '@universe/orion';

const NewFeatureBadgeWithExpiry = ({ releaseDate, customIcon }) => {
  // component takes in a releaseDate Date object
  // NewFeatureBadge will disappear 90 days after releaseDate

  const showSVG = isReleaseDateExpired(releaseDate);

  return showSVG ? (
    customIcon || <Pill variant="new" text="NEW" />
  ) : null;
};

export default NewFeatureBadgeWithExpiry;
